
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.387 16.482c.234 0 .45-.058.646-.175.196-.117.353-.274.47-.47.117-.197.176-.415.176-.655 0-.358-.123-.657-.37-.897l-6.16-6.302a1.672 1.672 0 00-.493-.364 1.316 1.316 0 00-.562-.119c-.393 0-.747.161-1.064.483l-6.16 6.302c-.118.123-.209.26-.273.409-.065.15-.097.312-.097.488 0 .24.059.458.176.654.117.197.272.353.466.47.193.118.41.176.65.176.37 0 .686-.137.95-.413l5.355-5.513 5.34 5.513c.235.25.518.387.849.41l.1.003z","fill":"#41807A"}})])
          )
        }
      }
    